import { render, staticRenderFns } from "./CompanySearchPrefForm.vue?vue&type=template&id=f451763c&"
import script from "./CompanySearchPrefForm.vue?vue&type=script&lang=js&"
export * from "./CompanySearchPrefForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports